var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.141,
    height: 17.216,
    viewBox: "0 0 15.141 17.216",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11133",
    "data-name": "Gruppe 11133",
    transform: "translate(-27.542 187.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_250",
    "data-name": "Pfad 250",
    d: "M16.57,6.944,9,11.012V24.16h6.056V17.095h3.028V24.16h6.056V11.012Zm6.561,16.207H19.094V16.085H14.047v7.066H10.009V11.616L16.57,8.09l6.561,3.526Z",
    transform: "translate(18.542 -194.411)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.f1bd29aeafffa410e6f164838915267e.svg";